var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.367 6.38-2.071 2.071a.54.54 0 0 1-.764 0l-4.987-4.986a.54.54 0 0 1 0-.764l2.071-2.07c.84-.841 2.206-.841 3.05 0l2.7 2.699c.845.84.845 2.206 0 3.05Zm-9.6-1.9L.968 16.277l-.952 5.458a1.08 1.08 0 0 0 1.249 1.25l5.458-.958L18.521 10.23a.54.54 0 0 0 0-.763L13.534 4.48a.545.545 0 0 0-.768 0ZM5.573 15.266a.626.626 0 0 1 0-.89l6.918-6.917a.626.626 0 0 1 .89 0 .626.626 0 0 1 0 .889l-6.919 6.918a.626.626 0 0 1-.889 0Zm-1.622 3.778H6.11v1.631l-2.898.508-1.397-1.397.507-2.898h1.631v2.156Z",
    fill: "#D7D9DB"
  })));
};
export default SvgPen;